const itemFilter = (item, filter)=> {
    if ( filter.namefilter ) {
        if ( !item.literal.toLowerCase().includes(filter.namefilter.toLowerCase() ) ) return false;
    }
    if ( filter.coursefilter ) {
        if ( !item.code.includes( filter.coursefilter ) ) return false;
    }
    if ( filter.endorsementfilter ) {
        let hasEndorsement = false;
        for ( let x in item.endorsements ) {
            let thisEndorsement = item.endorsements[x];
            if ( thisEndorsement.endorsement_code.includes( filter.endorsementfilter) ) hasEndorsement = true;
            if ( !hasEndorsement && thisEndorsement.endorsement.literal.includes( filter.endorsementfilter.toUpperCase() ) ) hasEndorsement = true;
        }
        if ( !hasEndorsement ) return false;
    }
    // Grade filter from "Recommended Level" in description
if (filter.gradefilter.length > 0 && item.description) {
    const match = item.description.match(/Recommended Level:\s*([A-Za-z0-9,\s]+)/i) ; 

    if (match && match[1]) {
        const grades = match[1].split(',').map(g => g.trim());

        // Check if ANY selected grade is in the recommended list
        const hasMatch = filter.gradefilter.some(g => grades.includes(g));

        if (!hasMatch) return false;
    } else {
        return false;
    }
}
    return true;
};

export default itemFilter;
